export default {
    general: {
        back: "Retour",
        validate: "Valider",
        confirm: "Confirmer",
        delete: "Supprimer",
        save: "Sauver",
        loading: "Chargement",
        share: "Partager",
        download: "Télécharger",
        retry: "Réessayer",
        html5NotSupported: "Votre navigateur ne suporte pas les vidéos HTML5.",
        permissionError: "Permission manquante",
        motionPermissionRefused:
            "La vue AR nécessite l'accès aux mouvements du téléphone. Veuillez redémarrer votre navigateur et accorder l'accès à la demande de détecteur de mouvement.",
        GCU: "Conditions générales d'utilisation",
        serverError: "Erreur serveur",
        camera: "Caméra",
        landscapeMessage: "Veuillez tenir votre appareil en portrait",
        rgpdUrl: "https://ar-go.co/fr/stqr-politique-de-confidentialite/",
        RGPDLinkText: "Politique de confidentialité",
        or: "ou",
        cancel: "Annuler",
        send: "Envoyer",
    },
    rgpd: {
        popinTitle: "Avant d'aller plus loin, nous avons besoin de ton accord :",
        termsAndConditionsText:
            "J’accepte les <a target='blank' href='https://ar-go.co/fr/stqr-conditions-generales-dutilisation/?fbclid=IwAR06X4GKvo1T987KEVciGOCttCWNvepzMKAJ1uu54JHVwZNG6DqmfbAhc_k'>conditions générales d’utilisation</a> et la <a target='blank' href='https://ar-go.co/fr/stqr-politique-de-confidentialite/'>politique de confidentialité</a>.",
        shareEmailText:
            "J’accepte de transmettre à l’émetteur de ce QR code l’email associé à mon compte, pour qu’il puisse me contacter dans le cadre de cette expérience seulement.",
        acceptAll: "Tout accepter",
        rejectAll: "Tout refuser",
        submit: "Valider",
        error: {
            termsAndConditionsCheckboxRequired:
                "Vous devez accepter les conditions générales d’utilisation et la politique de confidentialité pour poursuivre l'expérience."
        }
    },
    home: {
        record: "Enregistrer ma vidéo",
        edit: "Modifier",
        changeBrowser: "Navigateur non supporté",
        changeBrowserDetail:
            "Désolé, l'application n'est pas compatible avec votre navigateur. Merci d'utiliser Chrome ou Firefox sur Android et Safari sur iOS.",
        copyUrl: "Copier l'URL",
        adBannerTitle: "Ne manquez pas l'offre du Mois !",
        adBannerText: "stqr vous intéresse ? Contactez-nous pour en savoir plus",
        adBannerUrl: "https://ar-go.co/fr/stqr/#stqr-contact",
        leftCTATitle: "Contact",
        rightCTATitle: "Liens",
        processingVideo: "Veuillez patienter, votre vidéo est en cours de traitement..."
    },
    ar: {
        firstPopin: "Placez le repère sur une surface plane face à vous",
        secondPopin: "Cliquez sur le repère pour lancer l'animation"
    },
    optionalSignUp: {
        intro:
            "Tu pourras éditer à tout moment les vidéos liées à tes QR Codes sur ton compte <a href='https://admin.stqr.io' target='_blank'>stqr.io</a>.",
        createAccount: "Créer un compte personnel",
        noSignUp: "Continuer sans inscription",
        warning: "Attention !",
        warningMessage:
            "Tu ne pourras pas revenir modifier ni supprimer tes vidéos personnelles une fois celles-ci déposées.",
        recommended: "recommandé"
    },
    signInUp: {
        introSignUp:
            "Inscris-toi pour ajouter ton message vidéo personnalisé. Tu pourras éditer à tout moment les vidéos liées à tes QR Codes sur ton compte <a href='https://admin.stqr.io' target='_blank'>stqr.io</a>.",
        signIn: "S'identifier",
        emailAddress: "Adresse e-mail",
        password: "Mot de passe",
        passwordConfirm: "Confirmation du mot de passe",
        createAccount: "Créer un compte",
        firstName: "Prenom",
        lastName: "Nom",
        alreadyHaveAccount: "J'ai déjà un compte",
        googleSignIn: "Se connecter avec Google",
        forgetPasswordTitle: "Mot de passe oublié",
        forgetPasswordTutorial:
            "Merci d'entrer votre adresse email, nous vous enverrons un mail avec un nouveau mot de passe.",
        forgetPasswordSuccess: "Email envoyé",
        onSignUpPopinTitle: "Merci d’avoir créé votre compte stqr",
        onSignUpPopinText:
            "Un email avec le lien d’accès à votre compte vous a été envoyé. Vous pouvez éditer vos videos à tout moment en vous connectant à votre compte personnel stqr.",
        remindsMe:
            "J’autorise le dépôt d’un cookie local pour ne pas avoir à ressaisir mes identifiants de compte à chaque utilisation du service",
        notQrOwner: "Ce compte n'est pas propriétaire du message",
        ATHERR00_EMAIL: "Format email incorrect",
        ATHERR00_NAME: "Format nom incorrect",
        ATHERR00_PWD: "Mot de passe incorrect",
        ATHERR00_INC: "Données incorrectes",
        ATHERR01: "Données incorrectes",
        ATHERR02: "Compte déjà existant",
        ATHERR03: "Utilisateur non trouvé",
        ATHERR04: "Ce compte Google n'a pas les autorisations nécessaires",
        INTERR0: "Une erreur est survenue",
        notInDemo: "Fonctionnalité indisponible en mode démonstration",
        pwdLength: "Le mot de passe doit comporter 10 à 12 caractères",
        pwdNumberRequired: "Inclure un chiffre",
        pwdUpperRequired: "Inclure des caractères majuscules et minuscules",
        pwdNoSpace: "Ne pas inclure d'espaces",
        pwdNoMatch: "Les mots de passe ne correspondent pas",
        "Network Error": "Erreur de connexion au serveur",
        unknownError: "Une erreur est survenue",
        activateAccount: "Activer mon compte",
        introActivate: "Ne quittez pas cette page. Merci d'entrer le code d'activation reçu par email.",
        activationCode: "Code d'activation",
        activationError: "Error lors de activation."
    },
    record: {
        unsupported: "Format non supporté",
        available: "Formats : mov, mp4, avi, mpg",
        videoTooBigTitle: "Vidéo trop grande",
        videoTooBigText:
            "Votre vidéo ne doit pas dépasser {maxSize}Mo ({currentSize}Mo actuellement)",
        videoTooLongTitle: "Vidéo trop longue",
        videoTooLongText: "Votre vidéo ne doit pas dépasser {maxDuration} secondes",
        videoPickingText:
            "Cliquez sur le bouton pour créer ou charger une vidéo.<br/>Pas plus de { maxDuration } secondes pour une expérience optimale."
    },
    upload: {
        uploading: "Transfert de la vidéo",
        experienceCreating: "Création de votre expérience",
        uploadError: "Une erreur est survenue lors de l'envoi de la vidéo."
    },
    success: {
        doneMultiVideo: "Votre vidéo a bien été envoyée.",
        done: "C'est fait !",
        seeMyVideoAR: "Voir ma vidéo en RA",
        seeMyVideoHome: "Voir ma vidéo en plein écran"
    },
    share: {
        openTitle: "Découvrez stqr, le message video qui se colle partout",
        openText: "Démo",
        burnedTitle: "Vous avez un message vidéo"
    },
    desktop: {
        title: "Vous avez un message !",
        tutorialNoMessage:
            "<b>Scannez ce QR code</b> avec la caméra de votre téléphone pour poster un message vidéo.",
        tutorial:
            "<b>Scannez ce QR code</b> avec la caméra de votre téléphone pour voir le message vidéo.",
        tutorial2: "Ou ouvrez ce lien depuis votre smartphone ou tablette"
    },
    errors: {
        title: "Oups",
        qrcodeNotFoundTitle: "QRCode pas trouvé",
        qrcodeNotFoundText: "Impossible trouver le QR code... désolé.",
        serverErrorTitle: "Erreur serveur",
        serverErrorText: "Problème de connexion à notre serveur QRCode",
        networkErrorTitle: "Erreur réseau",
        networkErrorText:
            "Problème de connexion réseau. Certaines fonctionnalités peuvent ne pas être disponibles",
        timeout: "Temps mort",
        noGyro:
            "Votre appareil semble être incompatible avec l'affichage AR. Impossible d'accéder à l'orientation. Veuillez renouveler l'expérience sur un autre appareil.",
        videoConnectionProblems: "Vidéo ne peut pas être chargée"
    },
    report: {
        report: "Signaler",
        popinTitle: "Signaler",
        selectReason: "Veuillez sélectionner une raison",
        step2Title: "Votre signalement est anonyme",
        step2Subtitle:
            "Laissez-nous vos coordonnées si vous souhaitez être recontacté à propos de ce signalement.",
        step3Title: "Merci",
        step3Subtitle: "Votre signalement a été pris en compte",
        step3Text: "Nous procéderons à son évaluation dans les plus brefs délais",
        requiredField: "Champ obligatoire",
        keepMeInformed: "Je veux être informé",
        lastName: "Nom",
        firstName: "Prénom",
        email: "Email",
        message: "Message",
        close: "Fermer",
        bannedVideoMessage: "Cette vidéo a été supprimée suite à un signalement",
        reasons: {
            HATE: "Discours ou symboles haineux",
            NUDITY_SEX: "Nudité ou activité sexuelle",
            ANIMAL_CRUELTY: "Cruauté envers les animaux",
            SUICIDE_SELF_INJURY: "Suicide ou auto-mutilation",
            BULLYING: "Intimidation ou harcèlement",
            FAKE_NEWS: "Information mensongère",
            VIOLENCE: "Violence ou personnes dangereuses",
            SCAM: "Escroquerie ou fraude",
            SALE_ILLEGAL: "Vente de marchandises illégales, règlementées",
            INTELLECTUAL_VIOLATION: "Violation de propriété intellectuelle",
            CHILDREN_SAFETY: "Sécurité des mineurs"
        },
        errors: {
            invalidEmail: "L'adresse e-mail est incorrecte",
            emailFieldRequiredField: "Le champ e-mail est obligatoire",
            unknownError: "Une erreur est survenue, veuillez réessayer",
            EEXISTS: "Cette vidéo a déjà été signalée"
        }
    },
    reply: {
        title: "Saisissez votre réponse. Vous pouvez indiquer vos nom et prénom dans votre message",
        btnReply: "Je réponds",
        replySent: "Votre réponse envoyée avec succès !",
        firstName: "Prénom",
        lastName: "Nom",
        textAreaPlaceholder: "Entrer le texte",
        sending: "Envoi..."
    },
    inactive: {
        landingPageText: "Cette expérience a été désactivée par son propriétaire",
        banned: "Cette expérience a été bloquée par son propriétaire"
    },
    personalDataForm: {
        title: "Données personnelles",
        firstNameLabel: "Prénom",
        lastNameLabel: "Nom",
        emailLabel: "E-mail",
        phoneLabel: "Téléphone",
        errors: {
            fieldRequired: "Ce champ est requis",
            fieldValueIncorrect: "Valeur incorrecte",
            videoAgreement:
                "Vous devez accorder l'autorisation d'utiliser votre vidéo à des fins promotionnelles afin de poursuivre l'expérience"
        }
    },
    errorsUid: {
        STQRAPI_ERR_INTERNAL: "Erreur interne",
        STQRAPI_ERR_NOT_IMPLEMENTED: "Pas encore implémenté",
        STQRAPI_ERR_OBJECT_NOT_FOUND: "Object non trouvé",
        STQRAPI_ERR_INVALID_ID: "ID invalide",
        STQRAPI_ERR_CANT_GENERATE_TOKEN:"Impossible de générer le jeton",
        STQRAPI_ERR_WRONG_EMAIL_OR_PASSWORD: "Mauvais email ou mot de passe",
        STQRAPI_ERR_MIN_TOKEN_TTL: "Le TTL du jeton ne peut être inférieur à 1 seconde",
        STQRAPI_ERR_MAX_NORMAL_TOKEN_TTL: "Le TTL du jeton normal ne peut être supérieur à 7 jours",
        STQRAPI_ERR_MAX_SERVICE_TOKEN_TTL: "Le TTL du jeton de service ne peut être supérieur à 10 ans",
        STQRAPI_ERR_REQUIRED_PARAMETER: "[%s] est un paramètre obligatoire,",
        STQRAPI_ERR_INVALID_PARAMETER_VALUE: "Valeur invalide pour le paramètre [%s]",
        STQRAPI_ERR_INVALID_TOKEN: "Jeton invalide",
        STQRAPI_ERR_INVALID_TOKEN_PROVIDER: "Fournisseur de jeton invalide",
        STQRAPI_ERR_EMPTY_TOKEN: "Jeton vide",
        STQRAPI_ERR_CANT_GET_USER_FROM_TOKEN: "Impossible d'obtenir l'utilisateur STQR à partir du jeton",
        STQRAPI_ERR_NO_PERMISSIONS: "Vous n'avez pas la permission de le faire",
        STQRAPI_ERR_PARENT_CLIENT_IS_NOT_MULTI: "L'organisation mère n'est pas une organisation multiple",
        STQRAPI_ERR_INVALID_ROLE: "Rôle invalide",
        STQRAPI_ERR_INSUFFICIENT_RIGHTS: "Droits insuffisants",
        STQRAPI_ERR_INVALID_PASSWORD: "Mot de passe non valide. Le mot de passe doit comporter au moins 10 symboles (lettres anglaises, chiffres et tous les symboles spéciaux) sans espace. Le mot de passe doit comporter au moins une lettre majuscule et au moins un chiffre. Le mot de passe doit comporter au moins un symbole spécial:~, !,@,#,$,%,^,&,*,_,+.",
        STQRAPI_ERR_INVALID_CLIENT_ID: "Valeur de l'identifiant de l'organisation invalide",
        STQRAPI_ERR_CANT_SEND_PASSWORD_RESET_LINK: "Impossible d'envoyer le lien de réinitialisation du mot de passe",
        STQRAPI_ERR_PASSWORD_RESET_LINK_INVALID: "Le lien de réinitialisation du mot de passe n'est pas valide",
        STQRAPI_ERR_PASSWORD_RESET_LINK_EXPIRED: "Le lien de réinitialisation du mot de passe a expiré",
        STQRAPI_ERR_USERS_QUOTA_REACHED: "Le quota d'utilisateurs a été atteint",
        STQRAPI_ERR_NO_RIGHTS_TO_CREATE_SERVICE_TOKEN: "Vous n'avez pas le droit de créer un jeton de service",
        STQRAPI_ERR_SESSION_EXPIRED: "La session a expiré",
        STQRAPI_ERR_VALUE_TOO_BIG: "[%s] est trop grand. [%d] bytes autorisés",
        STQRAPI_ERR_VALUE_NOT_AVAILABLE: "La valeur [%s] du paramètre [%s] ne peut pas être définie",
        STQRAPI_ERR_CANT_DELETE_SYSTEM_USER: "L'utilisateur du système ne peut pas être supprimé",
        STQRAPI_ERR_SSO_MODE_ENABLED: "Cette opération n'est pas autorisée lorsque le mode sso est activé",
        STQRAPI_ERR_INVALID_EMAIL: "Email invalide. Symboles autorisés : [a-zA-Z0-9]+._-@'.",
        STQRAPI_ERR_ORGANIZATION_CANNOT_BE_DELETED_HAS_CHILDREN: "L'organisation avec ce identifiant ne peut pas être supprimée car elle a des enfants",
        STQRAPI_ERR_ORGANIZATION_CANNOT_BE_DELETED_HAS_USERS: "L'organisation avec ce identifiant ne peut pas être supprimée car elle a des utilisateurs",
        STQRAPI_ERR_USER_ALREADY_EXISTS: "L'utilisateur dont l'adresse électronique est spécifiée existe déjà dans cette application",
        STQRAPI_ERR_FILE_DOES_NOT_EXIST: "Le fichier fourni n'existe pas",
        STQRAPI_ERR_GUEST_ALREADY_EXISTS: "L'invité dont l'adresse électronique est spécifiée existe déjà dans cette application",
        STQRAPI_ERR_WRONG_ACTIVATION_CODE: "Code d'activation incorrect",
        STQRAPI_ERR_ACTIVATION_CODE_EXPIRED: "Code d'activation expiré",
        STQRAPI_ERR_CANT_SEND_GUEST_ACTIVATION_CODE: "Impossible d'envoyer le code d'activation de l'invité",
        STQRAPI_ERR_CANT_GET_GUEST_FROM_TOKEN: "Impossible d'obtenir l'utilisateur invité à partir du jeton",
        STQRAPI_ERR_NO_FILES_TO_PRESIGN: "Aucun fichier à signer. Veuillez fournir le paramètre “file[]” ou “files”.",
        STQRAPI_ERR_NO_RIGHTS_TO_SET_IS_SERVICE_TEMPLATE_FLAG: "Vous n'avez pas le droit de définir l'indicateur is_service_template",
        STQRAPI_ERR_TEMPLATE_USED_IN_PROJECTS: "Le template est utilisé dans les projets",
        STQRAPI_ERR_SERVICE_TEMPLATE_CANNOT_BE_UPDATED: "Le template de service ne peut pas être mis à jour",
        STQRAPI_ERR_SERVICE_TEMPLATE_CANNOT_BE_DELETED: "Le template de service ne peut pas être supprimé",
        STQRAPI_ERR_INVALID_PROJECT_TYPE: "Type de projet non valide",
        STQRAPI_ERR_INVALID_PROJECT_AUTH_TYPE: "Type d'autorisation de projet non valide",
        STQRAPI_ERR_INVALID_PROJECT_VIDEO_AGREEMENT_TYPE: "Type d'accord vidéo de projet non valide",
        STQRAPI_ERR_INVALID_PROJECT_SCHEDULED_DATES: "Dates prévues de projet non valides",
        STQRAPI_ERR_PROJECT_HAS_SHORTLINK_BATCHES: "Le projet a des lots de liens courts",
        STQRAPI_ERR_INVALID_SHORTLINK_REPORT_TYPE: "Type de rapport de liens courts non valide",
        STQRAPI_ERR_INVALID_SHORTLINK_REPORT_STATUS: "Invalid shortlink report status",
        STQRAPI_ERR_SHORTLINK_ALREADY_HAS_BURNS: "Le lien court a déjà été brûlé",
        STQRAPI_ERR_SHORTLINK_BATCH_AMOUNT_SHOULD_BE_POSITIVE: "Le montant du lot du lien court doit être positif",
        STQRAPI_ERR_GUEST_ALREADY_ACTIVATED: "L'invité est déjà activé",
        STQRAPI_ERR_USER_IS_NOT_ACTIVE: "L'utilisateur n'est pas actif",
        STQRAPI_ERR_PROJECT_REQUIRES_AUTH: "Le projet nécessite une autorisation",
        STQRAPI_ERR_SHORTLINK_BURN_VIDEO_TOO_LONG: "La vidéo est trop longue",
        STQRAPI_ERR_PROJECT_HAS_NO_PUBLIC_STATS: "Le projet n'a pas de statistiques publiques",
        STQRAPI_ERR_PROJECT_HAS_NO_PUBLIC_BURNS_DATA: "Le projet n'a pas de données publiques sur les brûlures",
        STQRAPI_ERR_TRANSCODER_CANNOT_PROCES_VIDEO: "Transcoder ne peut pas traiter la vidéo",
        STQRAPI_ERR_TRANSCODER_FILE_ON_EXTERNAL_STORAGE: "Transcoder ne peut pas traiter le fichier sur le stockage externe",
        STQRAPI_ERR_LOCKED_TEMPLATE_CANNOT_BE_UPDATED: "Le modèle verrouillé ne peut pas être mis à jour",
        STQRAPI_ERR_PROJECT_IS_NOT_COMMENTABLE: "Le projet ne peut pas être commenté",
        STQRAPI_ERR_SHORTLINK_IS_BANNED: "Le lien court est banni"
    }
};
